<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex md10 offset-md1 xs12 offset-xs0 mb-2>
                <span class="green--text">Torneos</span>
                <span class="ml-3 mr-3">></span>
                <span>Nuevo Torneo</span>
                <span class="ml-3 mr-3">></span>
                <span>Estadisticas</span>
            </v-flex>
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <v-tabs left :centered="false" light v-model="active">
                    <v-tabs-bar class="transparent">
                        <v-tabs-item
                        v-for="tab in tabs"
                        :key="tab.key"
                        :href="'#' + tab.key"
                        ripple
                        >
                        {{ tab.title }}
                        </v-tabs-item>
                        <v-tabs-slider color="green"></v-tabs-slider>
                    </v-tabs-bar>
                    <v-tabs-items :touchless="true">
                        <v-tabs-content key="tab1" id="tab1">
                            <positions-table :tournamentid="tournamentid" class="mt-3"></positions-table>
                        </v-tabs-content>

                        <v-tabs-content key="tab2" id="tab2">
                            <scorers-table :tournamentid="tournamentid" class="mt-3"></scorers-table>
                        </v-tabs-content>

                        <v-tabs-content key="tab3" id="tab3">
                            <yellow-cards-table :tournamentid="tournamentid" class="mt-3"></yellow-cards-table>
                        </v-tabs-content>

                        <v-tabs-content key="tab4" id="tab4">
                            <red-cards-table :tournamentid="tournamentid" class="mt-3"></red-cards-table>
                        </v-tabs-content>
                    </v-tabs-items>
                </v-tabs>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import PositionsTable from './PositionsTable'
    import ScorersTable from './ScorersTable'
    import YellowCardsTable from './YellowCardsTable'
    import RedCardsTable from './RedCardsTable'

    export default {
        name: 'Statistics',
        components: {
            PositionsTable,
            ScorersTable,
            YellowCardsTable,
            RedCardsTable
        },
        props: {
          tournamentid:{required: true, default: -1}
        },
        data() {
            return {
                active: 'tab1',
                tabs: [
                    { key: 'tab1', title: 'TABLA DE POSICIONES' },
                    { key: 'tab2', title: 'TABLA DE GOLEO' },
                    { key: 'tab3', title: 'TARJETAS AMARILLAS' },
                    { key: 'tab4', title: 'TARJETAS ROJAS' },
                ]
            }
        }
    }
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/statistics/Statistics.vue